import { OUTER_ROUTES } from '../constants';
import { Login } from '../views/pages/outer_layout/Login';

export const outerLayoutRoutes = [
  { path: OUTER_ROUTES.LOGIN, element: <Login /> },
];
